import { gsap, ScrollTrigger } from "@gsap";
/**
 * Layout: Contact CTA
 * Slug: contact_cta
 */

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.contact_cta-layout');

	layouts.forEach((layout) => {
		const imageShape = layout.querySelector(".shape");
		const image = layout.querySelector(".image-col img");
		let mm = gsap.matchMedia();
		
		mm.add("(min-width: 993px)", () => {
			gsap.from(imageShape, {
				xPercent: -5,
				scrollTrigger: {
					trigger: layout,
					scrub: 2
				}
			});
			gsap.from(image, {
				xPercent: 5,
				scrollTrigger: {
					trigger: layout,
					scrub: 2
				}
			});
		});
	});
});
